import { render, staticRenderFns } from "./ForumSearchBarComponent.vue?vue&type=template&id=0c3cbef6"
import script from "./ForumSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ForumSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ForumSearchBarComponent.vue?vue&type=style&index=0&id=0c3cbef6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports